<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col">
              <h3 class="card-title mb-0">Müşteriler</h3>
            </div>
            <div class="col text-right">
              <b-button v-b-modal.company variant="primary" v-if="roles && roles.includes('superadmin')">+ Yeni Ekle</b-button>
            </div>
          </div>
        </b-card-header>

        <b-table

          ref="table"
          class="align-items-center"
          thead-class="thead-light"
          :fields="fields"
          :items="items"
          @row-clicked="rowClick"
          responsive show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin!</b-alert>
          </template>

          <template v-slot:cell(expiration_date)="data">
            {{ date(data.item.expiration_date) }}
          </template>



          <template v-slot:cell(giris)="data">
            <button class="btn btn-primary btn-sm" @click="loginById(data.item.id)">
              Panele Gir
            </button>
          </template>

          <template v-slot:cell(actions)="data">
            <b-dropdown class="action-button" right>
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v" />
              </template>
              <b-dropdown-item @click="loginById(data.item.id)" class="dropdown-item-icon">
                <i class="fas fa-edit"></i>
                <span>Panele Gir</span>
              </b-dropdown-item>
              <b-dropdown-item :to="{name: 'company-detail', params: {id: data.item.id}}" class="dropdown-item-icon">
                <i class="fas fa-pen"></i>
                <span>Bilgileri Güncelle</span>
              </b-dropdown-item>
              <b-dropdown-item @click="openExpirationModal(data.item.id)" class="dropdown-item-icon">
                <i class="fas fa-pen"></i>
                <span>Son. Tarih</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="!data.item.is_frozen" @click="openFrozenModal(data.item.id)" class="dropdown-item-icon">
                <i class="fas fa-pen"></i>
                <span>Paneli Dondur</span>
              </b-dropdown-item>
              <b-dropdown-item v-else @click="openFrozen(data.item.id)" class="dropdown-item-icon">
                <i class="fas fa-pen"></i>
                <span>Paneli Aç</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteAction(data.item.id)" class="dropdown-item-icon">
                <i class="fas fa-trash"></i>
                <span>Sil</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>

        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">
          <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows" :per-page="pagination.perPage" />
        </div>
      </b-card>
    </div>

    <b-modal ref="company" id="company" @hide="resetCompany">
      <b-form-group label="Firma Adı">
        <b-form-input v-model="company.title" />
      </b-form-group>
      <b-form-group label="Yetkili Kişi">
        <b-form-input v-model="company.full_name" />
      </b-form-group>
      <b-form-group label="GSM">
        <b-form-input v-model="company.phone" v-mask="'+90 (###) ### ## ##'" />
      </b-form-group>
      <b-form-group label="Firma Telefonu">
        <b-form-input v-model="company.phone2" v-mask="'+90 (###) ### ## ##'" />
      </b-form-group>
      <b-form-group label="E-mail">
        <b-form-input v-model="company.email" />
      </b-form-group>
      <b-form-group label="Şifre">
        <b-form-input type="password" v-model="company.password" />
      </b-form-group>
      <b-form-group label="Son. Tarih">
        <b-form-input v-model="company.expiration_date" type="date" />
      </b-form-group>
      <b-col xs="12" md="12">
        <b-form-group label="Ürünlere Beden ve Yıl Girebilsin mi?">
          <b-form-select v-model="company.yearsize_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col xs="12" md="12">
        <b-form-group label="Cari Fotoğrafı Ekleyebilsin Mi?">
          <b-form-select v-model="company.productimage_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <template v-slot:modal-footer>
        <b-button @click="$refs.company.hide()">Kapat</b-button>
        <b-button @click="create()" variant="primary">Kaydet</b-button>
      </template>
    </b-modal>

    <b-modal ref="expiration" title="Son. Tarih Güncelle" @hide="resetExpiration">
      <b-form-group label="Yeni Son. Tarihi">
        <b-form-input v-model="expiration" type="date" />
      </b-form-group>

      <template v-slot:modal-footer>
        <b-button @click="$refs.expiration.hide()">Kapat</b-button>
        <b-button @click="saveExpiration()" variant="primary">Kaydet</b-button>
      </template>
    </b-modal>

    <b-modal ref="frozen" title="Panel Dondurma" @hide="resetExpiration">
      <b-form-group label="Talep Edilen Ücret">
        <b-form-input v-model="frozen_price" type="number" />
      </b-form-group>

      <template v-slot:modal-footer>
        <b-button @click="$refs.frozen.hide()">Kapat</b-button>
        <b-button @click="saveFrozen()" :disabled="frozen_price<=0" variant="primary">
          Dondur!
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapActions,mapGetters } from 'vuex';
  import moment from 'moment'
  import request from "../../../request";
  export default {
    name: 'Companies',
    data () {
      return {
        id: '',
        frozen_price:0,
        expiration: '',
        pagination: {
          currentPage: 1,
          totalRows: 1,
          perPage: 15,
        },
        fields: [
          { key: 'expiration_date', label: 'Son. Tarih' },
          { key: 'title', label: 'Firma Adı' },
          { key: 'full_name', label: 'Yetkili Kişi' },
          { key: 'phone', label: 'GSM' },
          { key: 'phone2', label: 'Firma Telefonu' },
          { key: 'city', label: 'İl' },
          { key: 'county', label: 'İlçe' },
          { key: 'giris', label: '', tdClass: 'text-right' },
          { key: 'actions', label: '', tdClass: 'text-right' },
        ],
        company: {
          title: '',
          full_name: '',
          phone: '',
          phone2: '',
          email: '',
          password: '',
          expiration_date: '',
        }
      }
    },
    computed:{
      ...mapGetters(['roles'])
    },
    methods: {
      ...mapActions([
        'getCompanies',
        'deleteCompany',
        'createCompany',
        'changeCompanyExpiration'
      ]),
      saveFrozen(){
        request.post(`/companies/froze/${this.id}`,{
          id:this.id,
          frozen_price:this.frozen_price
        }).then(res=>{
          this.success(res.data.success)
          window.location.reload()
        }).catch(err=>{
          this.alert(err.message)
        })
      },
       loginById(id){
        request.post('loginById/'+id).then(async res=>{
          await localStorage.setItem("access_token", res.data.access_token)
          window.location.href = "/"
        })
      },
      saveExpiration() {
        this.changeCompanyExpiration({
          id: this.id,
          expiration: this.expiration,
        }).then(response => {
          this.success(response.data.message);
          this.$refs.expiration.hide();
          this.$refs.table.refresh();
        }).catch(error => {
          this.error(error.response.data.message);
        });
      },
      resetExpiration() {
        this.id = ''
        this.expiration = ''
      },
      openExpirationModal(id) {
        this.id = id;
        this.$refs.expiration.show();
      },
      openFrozenModal(id) {
        this.id = id;
        this.$refs.frozen.show();
      },
      openFrozen(id){
        request.post('companies/froze/'+id).then(res=>{
          this.success('Panel Başarıyla Açıldı')
          window.location.reload()
        })
      },
      date(t) {
        return moment(t).calendar(null, {
          lastDay : '[Dün]',
          sameDay : '[Bugün]',
          nextDay : '[Yarın]',
          lastWeek : '[Geçen] dddd',
          nextWeek : '[Gelecek] dddd',
          sameElse : 'L'
        })
      },
      create() {
        this.createCompany(this.company).then(response => {
          this.success(response.data.message);
          this.$refs.table.refresh();
          this.$refs.company.hide();
        })
      },
      resetCompany() {
        this.company = {
          title: '',
          full_name: '',
          phone: '',
          phone2: '',
          email: '',
          password: '',
          expiration_date: '',
          productimage_permission: 1,
          yearsize_permission: 1,
        };
      },
      rowClick(item) {
        this.$router.push({name: 'company-detail', params: {id: item.id}});
      },
      items() {
        return this.getCompanies(this.pagination.currentPage).then(data => data.data).then(res => {
          this.pagination.totalRows = res.total;
          return res.data;
        });
      },
      deleteAction(id) {
        this.deleteCompany(id).then(() => {
          this.$refs.table.refresh();
        })
      }
    }
  }
</script>
